import { AddGroupPluginModal } from "./AddGroupPluginModal";

export default AddGroupPluginModal;
